export function verifyIfFormCanSave(
	dataForm: {
		paddingTop: number;
		paddingBottom: number;
		videoLink: string;
	},
	setCanSaveModuleOnBack: React.Dispatch<React.SetStateAction<boolean>>,
	setMessageErrorForm: React.Dispatch<React.SetStateAction<string>>
) {
	if (dataForm.videoLink === '') {
		setCanSaveModuleOnBack(false);
		setMessageErrorForm('Preenha o campo "Video Link"');
		return;
	}

	setCanSaveModuleOnBack(true);
}
